import { useParams } from "react-router";
import { OfferPositionsTable } from "@/services/backend/htz/offers/components/offer-positions-table";

export function PositionsRoute() {
  const { offerId } = useParams();

  return <OfferPositionsTable offerId={offerId!} />;
}
